// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const LazyImage = require('client-v2/common/components/lazy-image')
const tag = require('client-v2/common/utils/hyperscript')
// Entry imports
const IntoHeader = require('client-v2/into-landing/containers/header/component-smart')
const IntoLinkModal = require('client-v2/into-landing/containers/link-modal/component-smart')
const UserProfileFeed = require('./containers/feed/component-smart')

const bem = BemEntity('IntoUserProfileLayout')

function IntoUserProfileLayout(props) {
  const { items, likeCount, user, onPaginate } = props
  const likeText = likeCount === 1 ? `${likeCount} Like` : `${likeCount} Likes`

  return (
    tag('div', {
      className: bem.block()
    },
      tag('div', {
        className: bem.element('sidebar')
      },
        tag(IntoHeader, {
          className: bem.element('header')
        }),
        tag('div', {
          className: bem.element('details')
        },
          tag(LazyImage,{
            className: bem.element('user-avatar'),
            sources: [ user['photo_url'] ]
          }),
          tag('div', {
            className: bem.element('username')
          },
            `@${user.username}`
          ),
          tag('div', {
            className: bem.element('name')
          },
            user['display_name']
          ),
          tag('div', {
            className: bem.element('likes')
          },
            likeText
          ),
          tag('div', {
            className: bem.element('bio')
          },
            user.bio
          )
        ),
        tag(IntoLinkModal, {
          className: bem.element('link-modal')
        })
      ),
      tag('div', {
        className: bem.element('feed')
      },
        tag(UserProfileFeed, {
          className: bem.element('grid'),
          items,
          onPaginate
        })
      )
    )
  )
}

module.exports = IntoUserProfileLayout
